<template>
</template>

<script>
export default {
    props: {
        google: { type: Object, required: true },
        map: { type: Object, required: true },
        marker: { type: Object, required: true },
        icon: { type: Object, required: true },
        visible: { type: Boolean, required: true },
    },

    data() {
        return {
            mapMarker: null,
        }
    },

    mounted() {
        this.mapMarker = new this.google.maps.Marker({
            position: this.marker.position,
            marker: this.marker,
            icon: this.iconConfig,
            objId: this.marker.objId,
        })

        if (this.visible) {
            this.mapMarker.setMap(this.map)
        }

        this.mapMarker.addListener('spider_click', (e) => {
            this.$emit('marker:click', this.marker)
        })
    },

    computed: {
        iconConfig() {
            return {
                url: this.icon.url,
                scaledSize: new this.google.maps.Size(this.icon.w, this.icon.h),
                // size: new google.maps.Size(73, 100),
            }
        },
    },

    watch: {
        visible(isVisible) {
            if (isVisible) {
                this.mapMarker.setMap(this.map)
            } else {
                this.mapMarker.setMap(null)
            }
        },
    },

    beforeDestroy() {
        this.mapMarker.setMap(null)
        this.mapMarker = null
    },
}
</script>
